import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { faAngleUp } from '@fortawesome/free-solid-svg-icons'

class NewsForm extends React.Component {

    constructor(props) {
        super(props);
        this.initialState = {
            isFormShow: true,
            uid: '',
            title: '',
            url: '',
        }
        if (props.itemToEdit) {
            props.itemToEdit.isFormShow = true;
            this.state = props.itemToEdit
        } else {
            this.state = this.initialState;
        }
    }

    handleShowForm = () => {
        this.setState(this.initialState);
        this.setState({
            isFormShow: !this.state.isFormShow
        });
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.handleSubmit(this.state);
        this.setState(this.initialState);
    }

    render() {
        const { isFormShow, title, url } = this.state;
        const textButtom = isFormShow ? 'Ocultar Formulario' : 'Mostrar Formilario';
        const iconButton = isFormShow ? faAngleUp : faAngleDown;

        const isInvalid = title === '' || url === '';

        return (
            <div>
                <div className="accordion" id="accordionOfferForm">
                    <div className="nav justify-content-end">
                        <button onClick={this.handleShowForm} className="btn btn-dark btn-sm" type="button" data-toggle="collapse" data-target="#offerFormCollapse" aria-expanded="true" aria-controls="offerFormCollapse">
                            {textButtom}
                            <FontAwesomeIcon className="ml-2" icon={iconButton} />
                        </button>
                    </div>
                    <div id="offerFormCollapse" className="collapse show" data-parent="#accordionOfferForm">
                        <div className="pt-2 pl-3 pr-3">
                            <form onSubmit={this.handleSubmit}>
                                <div className="">
                                    <div className="row">
                                        <div className="col col-12 col-md-6 p-2">
                                            <input className="form-control" value={title} type="text" onChange={this.handleChange} name="title" placeholder="Título" />
                                        </div>
                                        <div className="col col-12 col-md-6 p-2">
                                            <input className="form-control" value={url} type="url" onChange={this.handleChange} name="url" placeholder="Enlace" />
                                        </div>

                                        <div className="col-12 nav justify-content-end p-2">
                                            <button disabled={isInvalid} type="submit" className="btn btn-success">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>



            </div>
        );
    }

}

export default NewsForm
